import React from "react";

export const playerCard = (yellowCard?: number, redCard?: number) => {
    if (yellowCard === 1 && redCard !== 1) {
        return (
            <i className="u-icon u-icon--tny u-icon--card u-icon--card--rotate u-icon--card--yellow" />
        );
    } else if (redCard === 1 || (yellowCard === 1 && redCard === 1)) {
        return (
            <i className="u-icon u-icon--tny u-icon--card u-icon--card--rotate u-icon--card--red" />
        );
    } else if (yellowCard === 2) {
        return (
            <i className="u-icon u-icon--tny u-icon--card u-icon--card--combined" />
        );
    }
};